import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';
import Cookies from 'js-cookie';
import { Header, Menu, Footer } from 'webmotors-react-pj/frame/logged';// eslint-disable-line


import styled from 'styled-components';
import AuthenticateUser from '../AuthenticateUser';

import * as S from '../utilities/styledComponents/Gearbox';

import BackofficeHeader from '../backoffice/Components/BackofficeHeader';
import BackofficeFooter from '../backoffice/Components/BackofficeFooter';
import BackofficeMenu from '../backoffice/Components/BackofficeMenu';

const CockpitStyle = styled.article`
	/* a:hover {
		color: #ffffff;
		opacity: 1;
	}

	a.cockpit-header__navlink {
		color: #4D4C59;
		opacity: 0.7;
	}

	a.cockpit-header__navlink:hover {
		opacity: 1;
	}

	.svg svg {
		min-height: 16px;
		min-width: 16px;
		max-width: 256px;
		max-height: 256px;
	}

	.cockpit-menu {
		width: 100%;

		ul {
			margin: 0;
		}

		svg {
			vertical-align: unset;
		}
	}

	.cockpit-menu__list:last-child .cockpit-menu__link {
		text-transform: none;
		font-size: 14px;
	}

	.cockpit-header__settings .svg {
		display: block;
		height: 29px;
	}

  	.cockpit-header__notify {
    	padding: 0;
  	}

  	.cockpit-header button {
    	padding: 0;
	}

	.cockpit-footer * {
		color: #8B8C99;
	}

	.cockpit-header__home .svg {
		height: 87px;
		display: block;
	}

	.cockpit-footer {
		padding: 19px 32px;
	}

	.cockpit-footer__logo-webmotors {
		transform: translateY(0px);
	}

	.cockpit-footer__logo-santander {
		transform: translateY(-4px);
	}

	@media screen and (max-width: 1279px) {
		.cockpit-header__home {
			width: 96px;
			height: 78px;
		}

		.cockpit-header__home .svg {
			width: 96px;
			overflow: hidden;
			display: block;
			height: auto;
		}

		.cockpit-header--logged .cockpit-header__logo {
			padding: 8px 0px 4px 24px;
			display: block;
			margin: 0;
			height: 78px;
		}

		.cockpit-header__logo .st0 {
			display: none;
		}

		.cockpit-menu svg {
			vertical-align: top;
		}

		.cockpit-menu__name {
			font-size: 0.63em;
		}

		.cockpit-menu__link .svg {
			width: auto;
			margin: 0 auto 12px;
		}

		.cockpit-menu__icon {
			width: 20px;
			height: 20px;
			transform: translateY(4px);
		}
	}

	@media screen and (max-width: 1024px) {
		.cockpit-header--logged .cockpit-header__button-nav {
			width: 0;
		}
	} */
`;

const showHeader = (props) => {
    const { noHeader, isBackoffice } = props;
    if (noHeader) {
		return (
			<div style={{ display: 'none' }}>
				<Header />
			</div>
		);
    }
    if (isBackoffice) {
        return <BackofficeHeader data={props} />;
    }
    return <Header />;
};

const showFooter = (props) => {
    const { noFooter, blankFooter, isBackoffice } = props;
    if (noFooter) {
        return '';
    }

    if (blankFooter) {
        return <div style={{ padding: '32px 0' }} />;
    }

    if (isBackoffice) {
        return <BackofficeFooter />;
    }
    return <div style={{ marginLeft: '50px' }}><Footer /></div>;
};

const showSidebar = (props) => {
    const { noSidebar, isBackoffice } = props;
    if (noSidebar) {
        return '';
    }
    if (isBackoffice) {
        return <BackofficeMenu />;
    }

    return (
	<Menu />
    );
};

const showContent = (rest, props, Component) => {
	if (rest.isBackoffice) {
		if (process.env.NODE_ENV !== 'development' && Cookies.get('Token') === undefined) {
			window.location = 'https://cockpit.com.br/';
		}
	} else if (process.env.NODE_ENV !== 'development' && Cookies.get('CockpitLogged') === undefined) {
		window.location = 'https://cockpit.com.br/';
	}

    const { widthFull } = rest;
    if (widthFull) {
        return (
	<S.MainContent id="gearbox-content">
		<Component {...props} />
	</S.MainContent>
        );
    }
    return (
	<S.Wrapper>
		{showSidebar(rest)}

		<S.MainContent id="gearbox-content">
			<Component {...props} />
		</S.MainContent>
	</S.Wrapper>
    );
};

const PrivateRoute = ({ component: Component, ...rest }) => (
	<Fragment>
		<AuthenticateUser />

		<Route
			{...rest}
			render={props => (
                AuthenticateUser && (process.env.REACT_APP_ENV !== 'production' || !rest.inactiveProd)
                    ? (
	<CockpitStyle>
		{showHeader(rest)}

		{showContent(rest, props, Component)}

		{showFooter(rest)}
	</CockpitStyle>
                    )
                    : <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
            )}
		/>
	</Fragment>
);

const mapStateToProps = state => ({
    user: state.user,
});

export default connect(mapStateToProps)(PrivateRoute);
